import { useStoreState } from 'src/stores';
import { FeatureFlagKey } from './useFeatureFlags.types';

export const useFeatureFlagEnabled = (featureFlag: FeatureFlagKey): boolean => {
  const featureFlags = useStoreState(state => state.auth.featureFlags);

  if (!featureFlags?.length) {
    return false;
  }

  return featureFlags.includes(featureFlag);
};
